import React, { useState, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { MapContext } from '../contexts/MapProvider';
import { dialColor } from '../styles/colors';
import { territories } from '../constants/territories';

const useStyles = makeStyles(() => ({
  container: {
    position: 'absolute',
    marginTop: 10,
    marginLeft: 10,
    zIndex: 10,
  },
  image: {
    width: '100%',
    height: '100%',
    filter:
      'invert(100%) sepia(3%) saturate(11%) hue-rotate(336deg) brightness(103%) contrast(603%)',
  },
  imgContainer: {
    width: 30,
    height: 30,
    overflow: 'hidden',
  },
  mainListItemIcon: {
    minWidth: 15,
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 7,
    paddingBottom: 7,
  },
  mainListButton: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})(props => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles(theme => ({
  root: {
    paddingTop: '4px !important',
    paddingBottom: '4px !important',
    minHeight: '40px !important',
    lineHeight: '1.75 !important',
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const ColorButton = withStyles({
  root: {
    color: '#FFFFFF',
    fontSize: 16,
    lineHeight: 1.5,
    backgroundColor: dialColor,
    borderColor: dialColor,
    '&:hover': {
      backgroundColor: dialColor,
      filter: 'brightness(90%)',
    },
    '&:active': {
      backgroundColor: dialColor,
    },
  },
})(Button);

function SelectTerritory() {
  const { flyTo } = useContext(MapContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTerritory, setSelectedTerritory] = useState(0);

  const classes = useStyles();

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const handleTerrClick = i => {
    setSelectedTerritory(i);
    flyTo(territories[i]);
    handleClose();
  };

  return (
    <div className={classes.container}>
      <ColorButton
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        onClick={handleClick}
        className={classes.mainListButton}
      >
        <ListItemIcon className={classes.mainListItemIcon}>
          <div className={classes.imgContainer}>
            <img
              src={`/${territories[selectedTerritory].name}.png`}
              alt={territories[selectedTerritory].name}
              className={classes.image}
            />
          </div>
        </ListItemIcon>
        {/* <ListItemText primary={territories[selectedTerritory].name} /> */}
      </ColorButton>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ marginLeft: -6 }}
      >
        {territories.map((territory, i) => (
          <StyledMenuItem
            onClick={() => handleTerrClick(i)}
            key={`territory-${i + 1}`}
            selected={i === selectedTerritory}
          >
            <ListItemIcon>
              <div className={classes.imgContainer}>
                <img
                  src={`/${territory.name}.png`}
                  alt={territory.name}
                  className={classes.image}
                />
              </div>
            </ListItemIcon>
            <ListItemText primary={territory.name} />
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </div>
  );
}

export default SelectTerritory;
